import { supabase } from '@/lib/supabase'

/* Games are public reference data — 0006 grants anon select and the policy is
   `using (true)`, so this works signed out too. Nothing here is pool-scoped. */

export async function fetchGamesForWeek(weekId: string) {
  // kickoff_at is nullable: weeks 16-18 have no published times until late in
  // the season and flex scheduling moves them. Postgres sorts NULLs last on an
  // ascending order, which is what we want — unscheduled games land at the
  // bottom rather than jumping to the top of the week.
  const { data, error } = await supabase
    .from('games')
    // home_score/away_score are here for the week board, which shades a pick by
    // whether it is currently ahead. The picks page ignores them.
    .select('id, week_id, home_team, away_team, kickoff_at, status, winner, home_score, away_score')
    .eq('week_id', weekId)
    .order('kickoff_at', { ascending: true })
  if (error) throw error
  return data
}
